import { gql } from '@apollo/client';

export const GET_CONFIGURATION = gql`
  query FetchConfiguration($language: String!, $configFields: [String!]) {
    fetchConfiguration(language: $language, configFields: $configFields)
  }
`;
